import { useState, useEffect } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Msg } from 'react-weui';
import PropTypes from 'prop-types';
import TopNav from 'components/topNav.js';
import * as MobileActions from 'actions/index.ts';
import useDetail from 'hooks/useDetail';
import Util from 'lib/util.js';
import Big from 'big.js';

function ProdDetail(props) {
  const Config = {
    purchase: {
      title: '物料档案详情',
      apiPath: '/archives/compProd/getDetail',
      companyCodeKey: 'companyCode',
      arrEnumField: [],
      idField: 'prodCode'
    }
  };
  const config = Config[props.type];
  const {
    companyCode,
    inited,
    error,
    updateTs,
    detail,
    setDetail,
    forceUpdate,
    self
  } = useDetail(props, config);

  const [customizeListObj1, setCustomizeListObj1] = useState({});
  const [customizeListObj2, setCustomizeListObj2] = useState({});
  const [customizeListObj3, setCustomizeListObj3] = useState({});

  //初始化默认企业
  useEffect(() => {
    const { match } = props;
    let routeCompanyCode = match.params.companyCode;
    self.init(routeCompanyCode);

    //卸载时
    return function unmount() {
      if (self.toastTimer) {
        clearTimeout(self.toastTimer);
      }
      if (self.loadingTimer) {
        clearTimeout(self.loadingTimer);
      }
      if (self.errorTimer) {
        clearTimeout(self.errorTimer);
      }
    };
  }, [self, props]);

  //根据依赖多次执行
  useEffect(() => {
    self.getDetail();
  }, [companyCode, self]);

  self.afterGetDetail = function (data) {
    setCustomizeListObj1(
      data.customizeList?.filter(item => item.categoryType === '2001')[0] || {}
    );
    setCustomizeListObj2(
      data.customizeList?.filter(item => item.categoryType === '2002')[0] || {}
    );
    setCustomizeListObj3(
      data.customizeList?.filter(item => item.categoryType === '2003')[0] || {}
    );
    setDetail(data);
    forceUpdate();
  };

  //显示错误
  if (error !== null) {
    return <Msg {...error} />;
  }

  return (
    <div>
      <TopNav inited={inited} />
      <div className="m-details-container">
        <div className="m-details-item">
          <div className="details-item-title">
            <label>基础信息</label>
          </div>
          <div className="details-item-content">
            <div className="content-line">
              <ul className="field-list">
                <li>
                  <span className="field-label">物料编码</span>
                  <div className="field-value">{detail.prodCode}</div>
                </li>
                <li>
                  <span className="field-label">物料名称</span>
                  <div className="field-value">{detail.prodName}</div>
                </li>
                <li>
                  <span className="field-label">物料规格</span>
                  <div className="field-value">{detail.prodScale}</div>
                </li>
              </ul>
            </div>
          </div>
        </div>

        <div className="m-details-item">
          <div className="details-item-title">
            <label>物料明细</label>
          </div>
          <div className="details-item-content">
            {updateTs > 0 && (
              <div className="content-line line-list-item">
                <ul className="field-list">
                  <li>
                    <span className="field-label">ERP分类</span>
                    <div className="field-value">
                      {detail.compProdInfos?.erpCategoryName}
                    </div>
                  </li>
                  <li>
                    <span className="field-label">分类1</span>
                    <div className="field-value">
                      {customizeListObj1?.categoryName}
                    </div>
                  </li>
                  <li>
                    <span className="field-label">分类2</span>
                    <div className="field-value">
                      {customizeListObj2?.categoryName}
                    </div>
                  </li>
                  <li>
                    <span className="field-label">分类3</span>
                    <div className="field-value">
                      {customizeListObj3?.categoryName}
                    </div>
                  </li>
                  <li>
                    <span className="field-label">检验否</span>
                    <div className="field-value">
                      {detail.compProdInfos?.isVerify === 1
                        ? '是'
                        : detail.compProdInfos?.isVerify === 0
                        ? '否'
                        : ''}
                    </div>
                  </li>
                  <li>
                    <span className="field-label">关联原材料</span>
                    <div className="field-value">
                      {detail.rawMaterials?.length > 0 &&
                        detail.rawMaterials[0]}
                    </div>
                  </li>
                  <li>
                    <span className="field-label">成本率</span>
                    <div className="field-value">
                      {!Util.isEmpty(detail.compProdInfos?.costRate) &&
                        Big(detail.compProdInfos?.costRate).times(100) + '%'}
                    </div>
                  </li>
                  <li>
                    <span className="field-label">预检</span>
                    <div className="field-value">
                      {detail.compProdInfos?.preVerifyFlag === 1
                        ? '是'
                        : detail.compProdInfos?.preVerifyFlag === 0
                        ? '否'
                        : ''}
                    </div>
                  </li>
                  <li>
                    <span className="field-label">备注</span>
                    <div className="field-value">
                      {detail.compProdInfos?.remark}
                    </div>
                  </li>
                  <li>
                    <span className="field-label">默认供应商</span>
                    <div className="field-value">
                      {detail.compProdInfos?.innerVendorName}{' '}
                      {detail.compProdInfos?.innerVendorCode}
                    </div>
                  </li>
                  <li>
                    <span className="field-label">默认仓库</span>
                    <div className="field-value">
                      {detail.compProdInfos?.invInName}
                    </div>
                  </li>
                  <li>
                    <span className="field-label">默认库位</span>
                    <div className="field-value">
                      {detail.compProdInfos?.locationInName}
                    </div>
                  </li>
                  <li>
                    <span className="field-label">默认税别</span>
                    <div className="field-value">
                      {detail.compProdInfos?.rateTypeName}
                    </div>
                  </li>
                  <li>
                    <span className="field-label">默认税率</span>
                    <div className="field-value">
                      {!Util.isEmpty(detail.compProdInfos?.defaultTaxRate) &&
                        detail.compProdInfos?.defaultTaxRate + '%'}
                    </div>
                  </li>
                  <li>
                    <span className="field-label">采购单位</span>
                    <div className="field-value">
                      {detail.basicUnitName}
                      {detail.basicUnitCode && '/' + detail.basicUnitCode}
                    </div>
                  </li>
                  <li>
                    <span className="field-label">计价单位</span>
                    <div className="field-value">
                      {detail.purchaseUnitName}
                      {detail.purchaseUnitCode && '/' + detail.purchaseUnitCode}
                    </div>
                  </li>
                </ul>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

ProdDetail.propTypes = {
  actions: PropTypes.object.isRequired
};

const mapDispatchToProps = dispatch => {
  return {
    actions: bindActionCreators(MobileActions, dispatch)
  };
};

export default connect(mapDispatchToProps)(ProdDetail);
